// extracted by mini-css-extract-plugin
export default {"container":"Dialog_container__RkUsd","dialogContents":"Dialog_dialogContents__HdZDt","headline":"Dialog_headline__dqbtV","button":"Dialog_button__NLcPK","dim":"Dialog_dim__yuYS9"};